// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"LoginPage_loginPage__32GRd"};